import { useNavigate } from "react-router";
import { useState } from "react";

import styled from "styled-components";
import styles from "./styles.module.css";

import { ReactComponent as LogoIcon } from "../../assets/logo.svg";
import { buttonClassName } from "../../Components/Button";
import { NavLink } from "react-router";
import Input from "../../Components/Input";
import { authLogin, authRegister } from "../../api/auth";

const Wrapper = styled.div`
  border-radius: 8px;
  padding: 40px;
  width: calc(560px - 2px + 40px * 2);
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  border: solid 1px rgba(255, 255, 255, 0.1);
  background-color: rgba(255, 255, 255, 0.03);
  border-radius: 0 0 8px 8px;
  position: relative;
  gap: 20px;
`;
const Header = styled.header`
  height: 44px;
  flex-shrink: 0;
  width: calc(560px + 40px * 2);
  background-color: rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Logo = styled(LogoIcon)`
  height: 20px;
  width: auto;
  color: #ededed;
`;
const Row = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  width: 100%;
`;
const Button = styled(NavLink)`
  flex-grow: 1;
  flex-shrink: 0;
`;
const Label = styled.div`
  color: #fff;
  text-transform: uppercase;
  font-size: 14px;
  line-height: 16px;
  font-weight: 500;
`;
const Group = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  position: relative;
  gap: 12px;
  & > * {
    width: 100%;
  }
`;

export function LoginPage({
  onSuccess,
}: {
  onSuccess?: (accessToken: string) => void;
}) {
  const [data, setData] = useState({
    email: "",
    password: "",
  });
  const navigate = useNavigate();

  return (
    <div className={styles.root}>
      <Header>
        <Logo />
      </Header>
      <Wrapper>
        <Row>
          <Button to="/auth/login" className={buttonClassName("dark")}>
            Login
          </Button>
          <Button to="/auth/signup" className={buttonClassName("dark")}>
            Sign Up
          </Button>
        </Row>
        <Group>
          <Label>Email</Label>
          <Input
            type="email"
            value={data.email}
            onChange={(e) =>
              setData((prev) => ({
                ...prev,
                email: e.target.value,
              }))
            }
          />
        </Group>
        <Group>
          <Label>Password</Label>
          <Input
            type="password"
            value={data.password}
            onChange={(e) =>
              setData((prev) => ({
                ...prev,
                password: e.target.value,
              }))
            }
          />
        </Group>
        <button
          className={buttonClassName()}
          type="button"
          style={{
            width: "100%",
          }}
          onClick={async () => {
            if (data.email === "" || data.password === "") {
              console.log("Please fill in all fields");
              return;
            }

            const result = await authLogin({
              email: data.email,
              password: data.password,
            });
            if (!result.success) return alert(result.error);

            console.log(`Logged in`);
            console.log(result.data);
            if (!onSuccess) navigate("/");
            else onSuccess(result.data.access_token);
          }}
        >
          Login
        </button>
      </Wrapper>
    </div>
  );
}

export function SignupPage() {
  const [data, setData] = useState({
    email: "",
    password: "",
    username: "",
  });
  const navigate = useNavigate();

  return (
    <div className={styles.root}>
      <Header>
        <Logo />
      </Header>
      <Wrapper>
        <Row>
          <Button to="/auth/login" className={buttonClassName("dark")}>
            Login
          </Button>
          <Button to="/auth/signup" className={buttonClassName("dark")}>
            Sign Up
          </Button>
        </Row>
        <Group>
          <Label>Email</Label>
          <Input
            type="email"
            value={data.email}
            onChange={(e) =>
              setData((prev) => ({
                ...prev,
                email: e.target.value,
              }))
            }
          />
        </Group>
        <Group>
          <Label>Username</Label>
          <Input
            value={data.username}
            onChange={(e) =>
              setData((prev) => ({
                ...prev,
                username: e.target.value,
              }))
            }
          />
        </Group>
        <Group>
          <Label>Password</Label>
          <Input
            type="password"
            value={data.password}
            onChange={(e) =>
              setData((prev) => ({
                ...prev,
                password: e.target.value,
              }))
            }
          />
        </Group>
        <button
          className={buttonClassName()}
          type="button"
          style={{
            width: "100%",
          }}
          onClick={async () => {
            if (
              data.email === "" ||
              data.password === "" ||
              data.username === ""
            ) {
              console.log("Please fill in all fields");
              return;
            }

            const result = await authRegister({
              email: data.email,
              password: data.password,
              username: data.username,
            });
            if (!result.success) return console.log(result.error);

            navigate("/login");
          }}
        >
          Signup
        </button>
      </Wrapper>
    </div>
  );
}
